var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5348_88716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95455 9.95221V4.82734L1.39684 3.3733L0 2.56641V9.04781C0 9.54822 0.397363 9.95221 0.886387 9.95221H2.95455Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 9.94825H12.115C12.6055 9.94825 13.0014 9.54276 13.0014 9.04385V2.5625L11.4193 3.4867L10.0469 4.82338V9.94825Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95415 4.82521L2.74219 2.82278L2.95415 0.90625L6.49959 3.61941L10.045 0.90625L10.2821 2.71931L10.045 4.82521L6.49959 7.53837L2.95415 4.82521Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 0.906927V4.82589L13.0014 2.56496V1.3591C13.0014 0.240709 11.7502 -0.396855 10.8742 0.27387L10.0469 0.906927Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.56498L1.35886 3.60488L2.95455 4.82591V0.906951L2.12723 0.273894C1.24973 -0.396884 0 0.240733 0 1.35908V2.56498Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5348_88716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.2cdea17c4b6d678c578aae8a8da2f6ef.svg";
export { ForwardRef as ReactComponent };